var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    viewBox: "0 0 30 30",
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.918 0h26.129v29.031H1.918Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.598 2.902H19.21v6.532H7.598Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb24b",
    d: "M7.734 0a2.924 2.924 0 0 0-2.902 2.902v7.258a2.902 2.902 0 0 0-2.898 2.906v7.258a2.9 2.9 0 0 0 2.898 2.903v2.902a2.922 2.922 0 0 0 2.902 2.902H25.13a2.922 2.922 0 0 0 2.902-2.902V7.859a1.41 1.41 0 0 0-.426-1.027L21.207.426A1.395 1.395 0 0 0 20.18 0Zm0 2.902h11.598v4.356c0 .8.648 1.453 1.45 1.453h4.347v1.45H7.734ZM4.832 13.066h1.453v2.73l1.363-2.73H9.27l-1.868 3.63 1.868 3.628H7.648L6.285 17.59v2.734H4.832Zm14.5 0h1.45v5.805h2.898v1.453h-4.348Zm-8.7.032h2.114l1.516 5.226 1.508-5.226h2.113v7.226H16.43v-1.957l.152-3.012-1.777 4.97h-1.102l-1.77-4.97.149 3.012v1.957h-1.45ZM7.735 23.227H25.13v2.902H7.734Zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb24b",
    d: "M16.629 4.215c-.43 0-.844.11-1.215.316-.45-.972-1.422-1.629-2.508-1.629-1.484 0-2.699 1.2-2.773 2.703a1.886 1.886 0 0 0-1.516 1.196 1.329 1.329 0 0 0-.988 1.293c0 .738.586 1.336 1.305 1.336h3.804V7.332h-.629c-.125 0-.164-.144-.093-.23.379-.47.914-.938 1.293-1.407a.116.116 0 0 1 .093-.047c.032 0 .067.012.094.047.379.47.914.938 1.293 1.407.07.085.031.23-.094.23h-.629V9.43h2.563c1.406 0 2.547-1.168 2.547-2.61 0-1.437-1.14-2.605-2.547-2.605Zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePost);
export default __webpack_public_path__ + "static/media/shapePost.a4315b0cd1c9b5e200eda26d5bde3a71.svg";
export { ForwardRef as ReactComponent };